import { Fragment } from 'react';
import { convertLegacyRouteRef } from '@backstage/core-compat-api';
import {
  PageBlueprint,
  coreExtensionData,
  createExtensionInput,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import {
  CatalogTable,
  catalogPlugin,
  type CatalogTableColumnsFunc,
} from '@backstage/plugin-catalog';
import CategoryIcon from '@material-ui/icons/Category';

/**
 * Overrides the catalog index page to drop the lifecycle and tags columns.
 *
 * Table columns are a prop on the page rather than an extension in
 * @backstage/plugin-catalog 2.0.6, so unlike the matching filters they cannot
 * be turned off from app-config. Everything else is left as upstream builds it.
 */

const HIDDEN_COLUMN_FIELDS = ['entity.spec.lifecycle', 'entity.metadata.tags'];

export const columns: CatalogTableColumnsFunc = context =>
  CatalogTable.defaultColumnsFunc(context).filter(
    column => !HIDDEN_COLUMN_FIELDS.includes(column.field as string),
  );

export const catalogPage = PageBlueprint.makeWithOverrides({
  inputs: {
    filters: createExtensionInput([coreExtensionData.reactElement]),
  },
  factory(originalFactory, { inputs }) {
    return originalFactory({
      path: '/catalog',
      routeRef: convertLegacyRouteRef(catalogPlugin.routes.catalogIndex),
      title: 'Catalog',
      icon: <CategoryIcon fontSize="inherit" />,
      loader: async () => {
        const { CatalogIndexPage } = await import(
          '@backstage/plugin-catalog/alpha'
        );
        return (
          <CatalogIndexPage
            filters={
              <Fragment>
                {inputs.filters.map(filter =>
                  filter.get(coreExtensionData.reactElement),
                )}
              </Fragment>
            }
            columns={columns}
            pagination
          />
        );
      },
    });
  },
});

export const catalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [catalogPage],
});
